module.exports = __webpack_public_path__ + "static/gallery6-9e5060ce3f33254a1799adb428cd773e.jpg";